import React from 'react';
const values = [{
  item: 'Posgrado en Nutrición Clínica',
  cost: '$180.000 - $400.000 ARS'
}, {
  item: 'Curso de Psiconutrición',
  cost: '$45.000 - $80.000 ARS'
}, {
  item: 'Curso certificado de FODMAP',
  cost: '$35.000 - $60.000 ARS'
}, {
  item: 'Curso de Nutrición Deportiva',
  cost: '$30.000 - $50.000 ARS'
}, {
  item: 'Asesoría de marketing para nutricionistas',
  cost: '$20.000 - $40.000 ARS por mes'
}, {
  item: 'Diseñador gráfico para plantillas de Canva',
  cost: '$15.000 - $30.000 ARS'
}, {
  item: 'Consultor de precios y honorarios',
  cost: '$10.000 - $20.000 ARS'
}];
export function ValueComparisonSection() {
  return <section className="py-20 bg-brand-sand" data-id="element-212">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-214">
          ¿Qué costaría obtener esto por separado?
        </h2>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-215">
          <div className="grid grid-cols-12 bg-gray-50 border-b border-gray-200 p-4 font-bold text-brand-teal" data-id="element-216">
            <div className="col-span-7 sm:col-span-8" data-id="element-217">Recurso</div>
            <div className="col-span-5 sm:col-span-4 text-right" data-id="element-218">
              Costo Aproximado
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-219">
            {values.map((v, i) => <div key={i} className="grid grid-cols-12 p-4 items-center hover:bg-gray-50 transition-colors" data-id="element-220">
                <div className="col-span-7 sm:col-span-8 text-gray-700 pr-4 text-sm sm:text-base" data-id="element-221">
                  {v.item}
                </div>
                <div className="col-span-5 sm:col-span-4 text-right text-gray-500 font-mono text-sm" data-id="element-222">
                  {v.cost}
                </div>
              </div>)}

            <div className="grid grid-cols-12 p-6 items-center bg-gray-50 border-t-2 border-gray-200" data-id="element-223">
              <div className="col-span-7 sm:col-span-8 text-gray-500 font-bold" data-id="element-224">
                Valor total equivalente
              </div>
              <div className="col-span-5 sm:col-span-4 text-right text-gray-400 font-mono font-bold line-through" data-id="element-225">
                $335.000 - $680.000 ARS
              </div>
            </div>

            <div className="grid grid-cols-12 p-6 items-center bg-brand-teal text-white" data-id="element-226">
              <div className="col-span-7 sm:col-span-8 font-bold text-xl" data-id="element-227">
                El Arsenal del Nutri
              </div>
              <div className="col-span-5 sm:col-span-4 text-right text-brand-accent font-mono font-bold text-2xl" data-id="element-228">
                $19.990 ARS
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}